"use strict";
angular.module('warnAlertModule', []).
controller('warnAlertCtrl', warnAlertCtrl);
warnAlertCtrl.$inject = ["$scope", "$modalInstance","$compile", "$validation" , "trsHttpService", "trsspliceString", "modalDialog"];

function warnAlertCtrl($scope, $modalInstance, $compile, $validation,  trsHttpService, trsspliceString, modalDialog) {

        /**
     * [close description] 关闭
     */
    $scope.close = function() {
        // $modalInstance.dismiss();
         $modalInstance.close("success");
    };
}